import React, { useEffect, useState, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { useAllActiveOffices } from "repositories/scheduler-repository";
import "../../Scheduler/components/SchedulerFilters/SchedulerFilters.scss";
import constants from "../../../../constants";

/**
 * Office filter for Compliance Dashboard: uses same API as Add Policy Folder
 * (/Office/AllActive) when section is expanded. Inline checkboxes, no modal.
 */
function OfficeFilterByAllActive({
  setOfficeFilter,
  selectedOffice,
  t,
  ownerId,
}) {
  const { data: officeData, isLoading } = useAllActiveOffices(
    1,
    constants.ACTIVE_OFFICES_PAGE_SIZE,
    ownerId
      ? { ownerId, includeAdminOffice: false, includeOwnerOffices: true }
      : null,
    "",
    { enabled: !!ownerId },
  );

  const officeList = useMemo(() => {
    if (!ownerId || !officeData?.data?.length) return [];
    return officeData.data
      .map((o) => ({
        id: o.id ?? o.officeId,
        name: o.name ?? o.officeName ?? "",
      }))
      .filter((o) => o.id != null);
  }, [ownerId, officeData]);

  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (
      selectedOffice?.length === officeList?.length &&
      officeList?.length > 0
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedOffice, officeList]);

  const handleChange = (e, item) => {
    const offices = [...(selectedOffice || [])];
    const idx = offices.findIndex((v) => Number(item.id) === Number(v));
    if (e.target.checked) {
      if (idx === -1) {
        offices.push(item.id);
      }
    } else if (idx > -1) {
      offices.splice(idx, 1);
    }
    setOfficeFilter(offices);
    setSelectAll(false);
  };

  const handleAllChange = (e) => {
    setSelectAll(e.target.checked);
    if (e.target.checked) {
      setOfficeFilter(officeList?.length ? officeList.map((o) => o.id) : []);
    } else {
      setOfficeFilter([]);
    }
  };

  if (!ownerId) return null;

  return (
    <ul className="filter-list">
      {isLoading && (
        <li className="small text-muted">{t("loading") || "Loading..."}</li>
      )}
      {!isLoading && officeList?.length > 0 && (
        <>
          <li>
            <div className="ch-checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={handleAllChange}
                  checked={selectAll}
                />{" "}
                <span>{t("officePolicyManagement.selectAll")}</span>
              </label>
            </div>
          </li>
          <hr className="mr-4" />
          {officeList.map((item) => (
            <li key={item.id}>
              <div className="ch-checkbox">
                <label>
                  <input
                    type="checkbox"
                    onChange={(e) => handleChange(e, item)}
                    checked={(selectedOffice || []).some(
                      (id) => Number(id) === Number(item.id),
                    )}
                  />{" "}
                  <span>{item.name}</span>
                </label>
              </div>
            </li>
          ))}
        </>
      )}
      {!isLoading && officeList?.length === 0 && (
        <li className="small text-muted">
          {t("officePolicyManagement.noOfficeAvailable")}
        </li>
      )}
    </ul>
  );
}

export default withTranslation()(OfficeFilterByAllActive);
